import axiosInstance from '@/utils/api.js'

var state = {
  deletedUsers: []
}

var getters = {
  DELETED_USERS: (state) => {
    return state.deletedUsers
  }
}

var mutations = {
  SET_DELETED_USERS: (state, payload) => {
    state.deletedUsers = payload
  }
}

var actions = {
  GET_DELETED_USERS: async (context, payload) => {
    let result = await axiosInstance.get('/users/deleted_users')
    if (result.status === 200) {
      context.commit('SET_DELETED_USERS', result.data)
    }
  },
  SEARCH_DELETED_USERS: async (context, payload) => {
    let result = await axiosInstance.post('/users/deleted_search', payload)
    if (result.status === 200) {
      context.commit('SET_DELETED_USERS', result.data)
    }
  },
  RESTORE_USERS: (context, payload) => {
    return axiosInstance.post('/users/restore_user', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/deletedUsers.js